import React from "react";
export function Footer() {
  return <footer className="border-t border-line px-5 py-10 text-center text-sm text-mute" data-id="element-54" data-mp="32wmqrybuniwl">
      <p className="font-display text-xl uppercase text-cream" data-id="element-55" data-mp="3gg0xpz2xhpvj">
        Guitar <span className="text-gold" data-id="element-56" data-mp="32onj8zjvni7d">Teacher</span>
      </p>
      <p className="mt-2" data-id="element-57" data-mp="32m1awxp5wyo3">Enseigner · Inspirer · Transformer</p>
      <nav className="mt-4 flex justify-center gap-6" aria-label="Liens légaux" data-id="element-58" data-mp="36q94b86kf2sn">
        <a href="#" className="transition-colors duration-150 hover:text-cream" data-id="element-59" data-mp="3ug3etj3ewf9q">Conditions d'utilisation</a>
        <a href="#" className="transition-colors duration-150 hover:text-cream" data-id="element-60" data-mp="37o2ul235f8m">Confidentialité</a>
        <a href="#" className="transition-colors duration-150 hover:text-cream" data-id="element-61" data-mp="3ldaphldsidmj">Contact</a>
      </nav>
      <p className="mt-6 text-xs" data-id="element-62" data-mp="3qc40961ozqj0">© 2026 Guitar Teacher. Tous droits réservés.</p>
    </footer>;
}